import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import { Route, HashRouter as Router, Routes, Link, useParams } from 'react-router-dom'
import Container from 'react-bootstrap/Container'
import Spinner from 'react-bootstrap/Spinner'
import 'bootstrap/dist/css/bootstrap.min.css';
import { InteractiveRenderer, Interactive, deepMap, hydrate } from '@bdg-ib/interactive-builder'
import { alphaNumericSort } from 'interactive'

const interactives = [
  {
    name: 'Ch 2: Reliability and Validity',
    path: '/reliability-and-validity',
    Component: React.lazy(() => import('./pages/ch2-reliability-and-validity')),
  },
  {
    name: 'Ch 3: Manipulating Construal',
    path: '/manipulating-construal',
    Component: React.lazy(() => import('./pages/ch3-manipulating-construal')),
  },
  {
    name: 'Ch 4: Heuristics',
    path: '/heuristics',
    Component: React.lazy(() => import('./pages/ch4-heuristics')),
  },
  {
    name: 'Ch 4: Animation',
    path: '/ch4-animation',
    Component: React.lazy(() => import('./pages/ch4-animation')),
  },
  {
    name: 'Ch 5: Affective Forecasting',
    path: '/affective-forecasting',
    Component: React.lazy(() => import('./pages/ch5-affective-forecasting')),
  },
  //{
  //  name: 'Ch 6: Cognitive Dissonance',
  //  path: '/cognitive-dissonance',
  //Component: React.lazy(() => import('./pages/ch6-cognitive-dissonance')),
  //},
  {
    name: 'Ch 8: Social Influence in Everyday Life',
    path: '/social-influence',
    Component: React.lazy(() => import('./pages/ch8-social-influence')),
  },
  {
    name: 'Ch 12: Power and Behavior',
    path: '/power-and-behavior',
    Component: React.lazy(() => import('./pages/ch12-power-and-behavior')),
  },
  {
    name: 'Ch 12: Animation',
    path: '/ch12-animation',
    Component: React.lazy(() => import('./pages/ch12-animation')),
  },
  {
    name: "Likert Graph Demo",
    path: "/demo",
    Component: React.lazy(() => import('./pages/demo')),
  }
]

const context = require.context('../public/interactives', true, /\.yml$/)
const context_paths = {}
const context_interactives = []
const context_names = {
  "cognitive-dissonance": "Ch 6: Cognitive Dissonance",
  "social-psych-14": "Ch 14: Helping Behavior",
  "chapter-7": "Ch 7: Attitude Inoculation",
  "chapter-10": "Ch 10: Contemporary Prejudice",
  "chapter-13": "Ch 13: Video Games and Aggression"
}
context.keys().forEach(k=>{
  const name = k.substr(2, k.length - 6)
  if (!name.endsWith(".manifest")) {
    context_interactives.push(name)
    context_paths[name] = k.substr(2)
  }
})
const context2 = require.context('../public/interactives', true, /\.json$/)
context2.keys().forEach(k=>{
  const name = k.substr(2, k.length - 7)
  if (!name.endsWith(".manifest")) {
    context_interactives.push(name)
    context_paths[name] = k.substr(2)
  }
})

console.log("sort", alphaNumericSort)

context_interactives.sort(alphaNumericSort);

const AdminPage = React.lazy(() => import('./AdminPage'));

function loadFetchedInteractive(r) {
  let i = new Interactive({
    ...r,
    panels: deepMap(r.panels, hydrate),
  })
  return i
}

function Path({partialTest}) {
  let { name } = useParams()
  let path = context_paths[name]
  console.log("Path", path)
  const [data, setData] = React.useState()
  const [error, setError] = React.useState()
  React.useEffect(()=>{
    if (data === undefined) {
      console.log("Path loading", `../public/interactives/${path}`)
      import(`../public/interactives/${path}`).then(data => {
        console.log("data", data)
        if (path.endsWith(".json")) {
          data.default.panels = data.default.panels.map(JSON.parse)
          setData(loadFetchedInteractive(data?.default))
        } else {
          setData(loadFetchedInteractive(data?.default?.interactive))
        }
      }).catch(e=>{
        console.log("Error", e)
        setError(e.message)
      })
    }
    return ()=>{
      console.log("Path unload")
    }
  }, [data, name, path])
  if (data) {
    console.log("staging data")
    return <InteractiveRenderer fullWidth data={data} attributes={{interactiveId: `social-psych-${name}`, interactiveIds: data.interactiveIds}}/>
  }
  if (error) {
    return <code style={{whiteSpace: 'pre', color: 'red'}}>{error}</code>
  }
  return <Spinner animation="border"/>
}

function LandingPage(props) {
  console.log("LandingPage")
  //const [names, setNames] = React.useState(context_interactives);
  /*React.useEffect(()=>{
    impo//rt('./index.json').then(r=>{
      console.log("import r", r)
      let arr = names.slice()
      for (const i of r.interactives) {
        arr.push(i.substring(0, i.length - 5));
      }
      setNames(arr);
    }).catch(e=>{
      throw e;
    })
  }, [])*/
  return <div style={{width: '540px', margin: 'auto'}}>
    <h2>Social Psych</h2>
    <ul>
      {interactives.map(({name, path})=>{
        return <li>
          <Link to={path}>{name}</Link>
        </li>
      })}
      {context_interactives.map(name=>{
        return <li>
          <Link to={`/${name}`}>{context_names[name] || name}</Link>
        </li>
      })}
    </ul>
    <span className="bdg-link">
      <Link to={`/collections/interactives`}>BDG</Link>
    </span>
  </div>
}

function RoutePath(props) {
  const params = useParams()
  const name = params?.name
  return <Path key={name} name={name}/>
}

ReactDOM.render(
  <React.StrictMode>
    <Container>
      <Router>
        <Suspense fallback={<Spinner animation="border"/>}>
          <Routes>
            {interactives.map(({ name, path, Component }) => {
              return (
                <Route
                  key={path}
                  exact
                  path={path}
                  element={
                    <Suspense fallback={<Spinner animation='border' />}>
                      <Component />
                    </Suspense>
                  }
                />
              )
            })}
            <Route path="/collections/interactives/*" element={<AdminPage/>}/>
            <Route exact path="/" element={<LandingPage/>}/>
            <Route path={`/:name`} element={<RoutePath/>}/>
          </Routes>
        </Suspense>
      </Router>
    </Container>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
